module.exports = __webpack_public_path__ + "static/img/service_banana01.6b0fbd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/service_banana01.png
// module id = fMHw
// module chunks = 0